import React from "react";
import MUIButton from "@mui/material/Button";

interface SecondaryButtonProps {
  addStyle?: string;
  children: React.ReactNode;
  onClick?: () => void;
  // ... any other props you'd like to pass to the button
}

const SecondaryButton: React.FC<SecondaryButtonProps> = ({
  addStyle,
  children,
  onClick,
  ...otherProps
}) => {
  const defaultStyles =
    "!font-inter px-[22px] py-[8px] !rounded-[2px] !border-primary-lu-blue !text-[#0092C8] !text-[14px] !font-semibold shadow-lg !bg-white !tracking-[0.46px]";
  return (
    <MUIButton
      className={`${defaultStyles} ${addStyle}`}
      onClick={onClick}
      style={{
        boxShadow: "rgba(0, 0, 0, 0.1) 0px 2px 4px 0px",
        textTransform: "none",
        border: "1px solid #0092C8",
      }}
      {...otherProps}>
      {children}
    </MUIButton>
  );
};

export default SecondaryButton;
